@let items = displayedItems();

<div class="container-items">
    <!-- Cabeçalho da pasta (voltar ao nível da seção + renomear/remover) -->
    @if (currentFolder(); as folder)
    {
        <div class="folder-breadcrumb" animate.enter="slide-in-from-right">
            <div class="folder-breadcrumb-back" (click)="exitFolder()">
                <ra-icon icon="arrow-left" varColor="currentColor" [size]="22" />
                <span class="ra-overflow-ellipsis">{{ folder.name }}</span>
            </div>

            @if (!editDataService.currentSessionIsDisabled() && !editDataService.documentIsBlocked()) {
                <div class="folder-breadcrumb-actions">
                    <ra-icon
                        icon="edit"
                        varColor="currentColor"
                        [size]="18"
                        [raTooltip]="{ text: ('document.edit.checklist.folder.rename' | translate), position: 'top' }"
                        (click)="showRenameFolder.set(true)" />
                    <ra-icon
                        icon="trash"
                        varColor="accentRed"
                        [size]="18"
                        [raTooltip]="{ text: ('document.edit.checklist.folder.remove' | translate), position: 'top' }"
                        (click)="removeFolder()" />
                </div>
            }
        </div>
    }

    @if (items && items.length > 0)
    {
        @if (editDataService.currentSessionIsDisabled()) 
        {
            <ra-badge 
                [label]="('document.edit.sessionItems.sessionEditedElsewhereBadge' | translate)" 
                [variant]="'warning'"
            />
        }
        
        <div
            cdkDropList
            [cdkDropListAutoScrollStep]="8"
            (cdkDropListDropped)="drop($event)"
            class="items-list"
            [class.bulk-mode]="editDataService.selectedItems().length > 0"
            [class.has-editing]="!!textEditing.editingFieldId()">
            @for (item of items; track item._id; let i = $index; let last = $last)
            {
                <!-- Campo novo ACIMA do primeiro: a mesma pílula, na borda de cima da folha.
                     Aparece no hover do primeiro card; as outras ficam embaixo de cada card. -->
                @if (i === 0 && !editDataService.currentSessionIsDisabled() && !editDataService.documentIsBlocked()) {
                    <div class="insert-line before-first" [class.open]="insertOpenBefore(item._id)">
                        <button
                            type="button"
                            class="insert-pill"
                            data-menu-trigger
                            [disabled]="editService.loading()"
                            (click)="toggleInsertBefore(item._id, $event)">
                            <ra-icon icon="add" varColor="currentColor" [size]="12" />
                            <span>{{ 'document.edit.toolbar.insertField' | translate }}</span>
                        </button>
                    </div>
                }

                <!-- Onde o PDF vira a folha. Vem da paginação real da prévia (paged.js),
                     então vale para a config de quebra por seção, para o item de quebra e
                     para a quebra por altura, sem nenhuma conta aqui. -->
                @if (pdfPageStartByItemId()[item._id]; as pageNumber) {
                    <div class="page-break-marker" aria-hidden="true" animate.enter="marker-open" animate.leave="marker-close">
                        <span class="page-break-label">
                            {{ 'document.edit.pdfPreview.pageBreakAt' | translate: { page: pageNumber } }}
                        </span>
                    </div>
                }

                @if (item.type == 'TEXT' || item.type == 'SUBTITLE' || item.type == 'TITLE')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <text-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'IMAGE') 
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <image-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'VIDEO') 
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <video-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'GROUP_IMAGE')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <group-image-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'CHECKLIST_FOLDER')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <folder-card [field]="item" (open)="openFolder($event)" />
                    </div>
                }
                @else if (item.type == 'PAGE_BREAK')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <page-break-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'CALLOUT')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <callout-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'STATS')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <stats-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'TABLE')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <table-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'SEMAPHORE')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <semaphore-card [field]="item" />
                    </div>
                }
                @else if (item.type == 'CHART')
                {
                    <div cdkDrag class="drag-item" [class.is-preview-hover]="previewHoverItemId() === item._id" [attr.data-field-id]="item._id" animate.enter="card-enter" [style.--enter-delay]="staggerEnter() ? (i % 12) * 30 + 'ms' : '0ms'">
                        <chart-card [field]="item" />
                    </div>
                }

                <!-- A folha virou NO MEIO deste item: não há traço a desenhar (o card é um
                     bloco só no editor), então ele avisa onde o texto continua. -->
                <!-- Tabela que mostra a quebra entre as linhas dispensa o aviso no pé. -->
                @if (!pdfRowBreaksByItemId()[item._id] && pdfContinuesByItemId()[item._id]; as pageNumber) {
                    <div class="page-continues-marker" aria-hidden="true">
                        <span class="page-break-label">
                            {{ 'document.edit.pdfPreview.continuesOnPage' | translate: { page: pageNumber } }}
                        </span>
                    </div>
                }

                <!-- Campo novo ENTRE dois itens: a pílula aparece no hover do card de cima (ou
                     da própria linha) e abre o menu com "abaixo deste campo". Depois do último
                     item não: ali já está o "Inserir campo" do fim da folha. -->
                @if (!last && !editDataService.currentSessionIsDisabled() && !editDataService.documentIsBlocked()) {
                    <div class="insert-line" [class.open]="insertOpenAfter(item._id)">
                        <button
                            type="button"
                            class="insert-pill"
                            data-menu-trigger
                            [disabled]="editService.loading()"
                            (click)="toggleInsertAfter(item._id, $event)">
                            <ra-icon icon="add" varColor="currentColor" [size]="12" />
                            <span>{{ 'document.edit.toolbar.insertField' | translate }}</span>
                        </button>
                    </div>
                }
            }
        </div>
    }
    @else if (editService.loading())
    {
        <!-- Skeletons da folha de itens enquanto a seção carrega -->
        <div class="items-list">
            @for (skeleton of itemSkeletons; track $index) {
                <item-card-skeleton />
            }
        </div>
    }
    @else if (!editDataService.currentSession())
    {
        <ra-empty 
            [title]="('document.edit.sessionItems.noSessionTitle' | translate)"
            [message]="('document.edit.sessionItems.noSessionMessage' | translate)"
        />
    }
    @else
    {
        <ra-empty 
            [title]="('document.edit.sessionItems.addItemTitle' | translate)"
            [message]="('document.edit.sessionItems.addItemMessage' | translate)" 
        />

        @if (editDataService.currentSessionIsDisabled()) 
        {
            <ra-badge 
                [label]="('document.edit.sessionItems.sessionEditedElsewhereBadge' | translate)" 
                [variant]="'warning'"
            />
        }
    }

    <!-- "Inserir campo" no fim da folha, depois do último campo. Some com a barra da
         seleção em lote. -->
    <insert-field-fab [items]="items ?? []" />

    @let isDisabled = editService.loading() || editDataService.currentSessionIsDisabled() || editDataService.documentIsBlocked();

    @if (editDataService.selectedItems().length > 0)
    {
        <!-- Barra de lote: superfície invertida, contagem + ações com rótulo -->
        <div class="selection-actions" animate.enter="actions-enter" animate.leave="actions-leave">
            @let selectedCount = editDataService.selectedItems().length;

            <span class="selection-count ra-label-s">
                @if (selectedCount === 1) {
                    {{ 'document.edit.sessionItems.selectedCountOne' | translate }}
                } @else {
                    {{ 'document.edit.sessionItems.selectedCount' | translate:{ count: selectedCount } }}
                }
            </span>

            <!-- Mover seleção para outra seção -->
            <button
                type="button"
                class="selection-action selection-action--move"
                [class.disabled]="isDisabled"
                [raTooltip]="{ text: ('document.edit.sessionItems.moveSelectedTooltip' | translate), position: 'top' }"
                (click)="showModalListSession.set(true)">
                @if (isDisabled) { <ra-loading /> }
                @else { <ra-icon icon="arrow-right" varColor="currentColor" [size]="16" /> }
                <span class="ra-label-s">{{ 'document.edit.sessionItems.moveSelectedLabel' | translate }}</span>
            </button>

            <!-- Remover seleção -->
            <button
                type="button"
                class="selection-action selection-action--remove"
                [class.disabled]="isDisabled"
                [raTooltip]="{ text: ('document.edit.sessionItems.removeSelectedTooltip' | translate), position: 'top' }"
                (click)="removerSelectedItems()">
                @if (isDisabled) { <ra-loading /> }
                @else { <ra-icon icon="trash" varColor="currentColor" [size]="16" /> }
                <span class="ra-label-s">{{ 'document.edit.sessionItems.removeSelectedLabel' | translate }}</span>
            </button>

            <span class="selection-divider"></span>

            <!-- Limpar seleção -->
            <button
                type="button"
                class="selection-action selection-action--clear"
                [class.disabled]="isDisabled"
                [raTooltip]="{ text: ('document.edit.sessionItems.clearSelectionTooltip' | translate), position: 'top' }"
                (click)="editDataService.cleanSelectedItems()">
                @if (isDisabled) { <ra-loading /> }
                @else { <ra-icon icon="close" varColor="currentColor" [size]="16" /> }
            </button>
        </div>
    }

    <!-- Menu de campos: popover ancorado em quem o abriu (barra do topo ou o card). -->
    <menu-options (openFavoriteFields)="showModalListFavoriteFields.set(true)" />

    @if (showScrollToBottom()) {
        <div class="scroll-to-bottom-wrap">
            <button
                type="button"
                class="button-scroll-to-bottom"
                animate.enter="scroll-button-enter"
                animate.leave="scroll-button-leave"
                [raTooltip]="{ text: ('common.sectionEditor.goToLastItem' | translate), position: 'top' }"
                (click)="scrollToBottom()"
                [attr.aria-label]="'common.sectionEditor.goToLastItem' | translate">
                <ra-icon icon="arrow-down" varColor="currentColor" [size]="18" />
            </button>
        </div>
    }
</div>

@if (showModalListSession()) {
    <modal-list-section (close)="showModalListSession.set(false)" />
}

<!-- Modal de listagem de campos favoritos -->
@if (chartWizard.state()) {
    <modal-chart />
}

@if (showModalListFavoriteFields()) {
    <modal-list-favorite-fields (close)="closeModalListFavoriteFields()" />
}

<!-- Em quantas colunas as imagens recém-selecionadas entram (só com mais de uma) -->
@if (imageColumnsService.pendingImagesCount(); as pendingImagesCount) {
    <modal-image-columns
        [imagesCount]="pendingImagesCount"
        (columnsSelected)="imageColumnsService.choose($event)"
        (close)="imageColumnsService.cancel()" />
}

<!-- Modal de renomear a pasta de checklist -->
@if (showRenameFolder()) {
    <ra-modal-edit-text
        [title]="'document.edit.checklist.folder.renameTitle' | translate"
        [placeholder]="'document.edit.checklist.folder.name' | translate"
        [value]="currentFolder()?.name || ''"
        [limitCharacters]="80"
        (close)="showRenameFolder.set(false)"
        (save)="saveRenameFolder($event)" />
}
